import ActionButton, {ActionButtonStyle} from "../ActionButton";
import BoxInput from "../BoxInput";
import BoxLink from "../BoxLink";
import CalendarInput from "../CalendarInput";
import Card from "../Card";
import CardBanner from "../CardBanner";
import CardPicker from "../CardPicker";
import Checkbox from "../Checkbox";
import CheckboxEnhanced from "../ CheckboxEnhanced";
import cn from "../../lib/classnames";
import CollegeInput from "../CollegeInput";
import DateOfBirthInput from "../DateOfBirthInput";
import DemoInputGroup from "../DemoInputGroup";
import DemoInputGroup2 from "../DemoInputGroup2";
import DownloadButton from "../DownloadButton";
import ErrorBoundary from "../ErrorBoundary";
import ErrorDemo from "./ErrorDemo";
import FundLaterReminderModal from "../FundLaterReminderModal";
import gradientStyles from "../../styles/Gradient.module.css";
import Header from "../Header";
import IconButton, {IconType} from "../IconButton";
import IdleTimeoutWrapper from "../IdleTimeoutWrapper";
import LinedInput, {InputType} from "../LinedInput";
import logger from "../../lib/logger";
import Modal, {modalStyles} from "../Modal";
import MoneyInput from "../MoneyInput";
import NavigationDemo from "./NavigationDemo";
import PersonalReferralCard from "../PersonalReferralCard";
import PhoneInput from "../PhoneInput";
import Quote from "../Quote";
import RadioGroup from "../RadioGroup";
import React, {useState, useRef, useEffect} from "react";
import ReviewCarousel, {ReviewDisplayInfo} from "../ReviewCarousel/ReviewCarousel";
import ReviewDescription from "../ReviewDescription";
import ReviewDisplay from "../ReviewDisplay";
import ReviewInput from "../ReviewInput";
import RoundedCard from "../RoundedCard/RoundedCard";
import securedCardImage from "../../images/secured.png";
import securedCardImage2 from "../../images/secured@2x.png";
import securedCardImage3 from "../../images/secured@3x.png";
import Select from "../Select";
import SocialSecurityInput from "../SocialSecurityInput";
import StarRating from "../StarRating";
import styles from "./Demo.module.css";
import TableDemo from "./TableDemo";
import TextLink from "../TextLink";
import textStyles from "../../styles/Text.module.css";
import {useHistory} from "react-router-dom";
import {RadioOption} from "../RadioGroup/RadioGroup";

const DEFAULT_TITLE_MIN_CHARS = 3;
const DEFAULT_MINIMUM_CHARS = 10;

export default function Demo() {
    const history = useHistory();
    const [boxInput, setBoxInput] = useState("");
    const [petIndex, setPetIndex] = useState(-1);
    const [birdIndex, setBirdIndex] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const [modal2Visible, setModal2Visible] = useState(false);
    const [fundLaterVisible, setFundLaterVisible] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [email, setEmail] = useState("");
    const [checkbox, setCheckbox] = useState(false);
    const [card, setCard] = useState("gold");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [ssn, setSSN] = useState("");
    const [college, setCollege] = useState("");
    const [money, setMoney] = useState("");
    const [rating, setRating] = useState(0);
    const [calendarValue, setCalendarValue] = useState<Date | null>(null);

    const buttonRef = useRef<HTMLButtonElement>(null);
    const button2Ref = useRef<HTMLButtonElement>(null);
    const fundLaterButtonRef = useRef<HTMLButtonElement>(null);

    const [reviewTitle, setReviewTitle] = useState("");

    const [hasTypedTitle, setHasTypedTitle] = useState(false);

    useEffect(() => {
        if (!hasTypedTitle && reviewTitle.length > 0) {
            setHasTypedTitle(true);
        }
    }, [hasTypedTitle, reviewTitle]);

    const titleCharsLeft = DEFAULT_TITLE_MIN_CHARS - reviewTitle.length;
    const titleMessageToDisplay =
        hasTypedTitle && titleCharsLeft > 0
            ? `Type ${titleCharsLeft} more ${titleCharsLeft === 1 ? "character" : "characters"}.`
            : "";

    const [cardDescription, setCardDescription] = useState("");
    const [hasTyped, setHasTyped] = useState(false);

    useEffect(() => {
        if (!hasTyped && cardDescription.length > 0) {
            setHasTyped(true);
        }
    }, [hasTyped, cardDescription]);

    const charsLeft = DEFAULT_MINIMUM_CHARS - cardDescription.length;
    const messageToDisplay =
        hasTyped && charsLeft > 0
            ? `Type ${charsLeft} more ${charsLeft === 1 ? "character" : "characters"}.`
            : "";

    const radioOptions: RadioOption[] = [
        {
            value: 0,
            label: "Make a deposit from a Debit Card Account.",
        },
        {
            value: 2,
            label: "Make a deposit from a Credit Card Account. Extra text for testing purposes.",
        },
        {
            value: 3,
            label:
                "Make a deposit from a Debit Card or Credit Card Account. Extra text for testing purposes.",
        },
    ];

    function getSecuredCardImage() {
        return (
            <img
                className={styles.cardsImage}
                src={securedCardImage}
                srcSet={`${securedCardImage} 1x, ${securedCardImage2} 2x, ${securedCardImage3} 3x`}
                alt="secured card"
            />
        );
    }

    const [radioValue, setRadioValue] = useState(-1);

    const reviews: ReviewDisplayInfo[] = [
        {
            id: "e7748eb9-c806-437a-8481-848214f223ff",
            rating: 5,
            description: '"Thank you for a great experience and easy to follow application"',
            dateOfReview: "May 2020",
        },
        {
            id: "355e75b3-6970-4c9b-8b14-f21d33baf790",
            rating: 5,
            description:
                '"1st Financial Bank USA allowed me to get my first credit card and I’m very thankful!"',
            dateOfReview: "January 2021",
        },
        {
            id: "80e88d59-3b45-4075-b50a-023bdd132b7d",
            rating: 5,
            description: '"I really liked the design and ease of use."',
            dateOfReview: "December 2020",
        },
        {
            id: "80e88d59-12ad-4075-b50a-023bdd132b7d",
            rating: 5,
            description: '"This is a review from the future!"',
            dateOfReview: "December 2044",
        },
    ];

    return (
        <ErrorBoundary>
            <IdleTimeoutWrapper focusAfterContinue={buttonRef.current}>
                <Header />

                <h1>Demo</h1>

                <NavigationDemo />

                <ErrorDemo />

                <div className={cn(styles.darkBackgroundContainer, styles.boxInputContainer)}>
                    <BoxInput
                        value={boxInput}
                        onChange={(e) => setBoxInput(e.target.value)}
                        label="test"
                        toggleText="This is some long text that should overflow on top. This is some long text that should overflow on top. This is some long text that should overflow on top."
                    />
                </div>
                <div className={cn(styles.darkBackgroundContainer, styles.boxInputContainer)}>
                    <BoxInput
                        value={boxInput}
                        onChange={(e) => setBoxInput(e.target.value)}
                        label="test"
                    />
                </div>
                <div className={cn(styles.darkBackgroundContainer, styles.boxInputContainer)}>
                    <BoxInput
                        value={boxInput}
                        onChange={(e) => setBoxInput(e.target.value)}
                        label="test"
                        toggleText="This is some text"
                    />
                </div>
                <div>
                    <div className={styles.blueBackground}>
                        <div className={textStyles.titleHero}>Hero Title</div>
                    </div>
                    <div className={textStyles.title}>Title</div>
                    <div className={textStyles.body}>
                        Body text with link to <TextLink to="/" text="Home (to)" />. Other body text
                        etc.
                    </div>
                    <div className={textStyles.body}>
                        Body text with link to <TextLink href="/" text="Home (href)" />. Other body
                        text etc.
                    </div>
                    <div className={textStyles.body}>
                        Body text with link to{" "}
                        <TextLink onClick={() => history.push("/")} text="Home (onClick)" />. Other
                        body text etc.
                    </div>
                    <div className={textStyles.titleHero}>Hero Title</div>
                </div>
                <div className={textStyles.title}>Title</div>
                <div className={textStyles.body}>
                    Body text with inline <span className={textStyles.link}>link to something</span>
                    . Other body text etc.
                </div>
                <div className={textStyles.input}>Valid Input</div>
                <div className={textStyles.inputPlaceholder}>Input Placeholder</div>
                <div className={textStyles.inputError}>Input Error</div>
                <div className={textStyles.inputLabel}>Input Label</div>
                <div className={textStyles.inputDetail}>Input Details</div>
                <div className={textStyles.legal}>Legal stuff, privacy disclaimer</div>
                <div className={textStyles.copyright}>Copyright label</div>
                <div style={{fontWeight: "bold"}}>bold text</div>
                <button ref={buttonRef} onClick={() => setModalVisible((m) => !m)}>
                    Test Modal
                </button>
                <button ref={button2Ref} onClick={() => setModal2Visible((m) => !m)}>
                    Test Modal 2
                </button>
                <button ref={fundLaterButtonRef} onClick={() => setFundLaterVisible((m) => !m)}>
                    Fund Later Reminder
                </button>
                <div className={styles.container}>
                    <ActionButton label="Primary" href="" />
                    <ActionButton label="Outlined" style={ActionButtonStyle.outlined} />
                    <ActionButton label="Outlined Small" style={ActionButtonStyle.outlinedSmall} />
                </div>
                <div className={styles.container}>
                    <IconButton
                        label="Copy"
                        iconType={IconType.Clipboard}
                        onClick={() => logger.log("click copy")}
                    />
                    <IconButton
                        label="Share"
                        iconType={IconType.Share}
                        onClick={() => logger.log("click share")}
                    />
                </div>
                <div className={styles.descriptionButtonContainer}>
                    <ActionButton
                        label="Descriptive Primary"
                        description="I have read and accept the Electronic Communications Agreement"
                        href=""
                    />
                </div>
                <div className={styles.fullWidthButtonContainer}>
                    <ActionButton label="Primary Full Width (Href)" href="/" fullWidth={true} />
                </div>
                <div className={styles.fullWidthButtonContainer}>
                    <ActionButton
                        label="Primary Full Width (Same Tab, Href)"
                        href="/"
                        openInSameTab={true}
                        fullWidth={true}
                    />
                </div>
                <div className={styles.darkBackgroundContainer}>
                    <ActionButton
                        label="Secondary (LinkTo)"
                        style={ActionButtonStyle.secondary}
                        linkTo="/"
                    />
                    <ActionButton
                        label="Secondary (Same Tab, LinkTo)"
                        style={ActionButtonStyle.secondary}
                        linkTo="/"
                        openInSameTab={true}
                    />
                    <ActionButton label="Outlined Dark" style={ActionButtonStyle.outlinedDark} />
                </div>
                <div className={styles.inputContainer}>
                    <Select
                        id="pet-select"
                        label="Select a Pet"
                        options={["Cat", "Dog", "Fish", "Lizard"]}
                        selectedIndex={petIndex}
                        setSelected={(index) => {
                            setPetIndex(index);
                        }}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <Select
                        id="pet-select-2"
                        label="Select a Pet"
                        options={["Cat", "Dog", "Fish", "Lizard"]}
                        selectedIndex={petIndex}
                        setSelected={(index) => {
                            setPetIndex(index);
                        }}
                        validationMessage={["Invalid pet"]}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <Select
                        id="bird-select"
                        label="Select a Bird"
                        options={["Eagle", "Parrot", "Swan", "Goose (evil)"]}
                        selectedIndex={birdIndex}
                        setSelected={(index) => {
                            setBirdIndex(index);
                        }}
                        noEmptyDefault={true}
                        extraInfo="Your choice of bird defines you, choose wisely"
                    />
                </div>
                <div className={styles.inputContainer}>
                    <CollegeInput
                        id="college-name"
                        onCollegeSelected={setCollege}
                        label="College (future or present)"
                        required={true}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <CollegeInput
                        id="college-name-errored"
                        onCollegeSelected={setCollege}
                        label="College (future or present)"
                        required={true}
                        validationMessage={["Invalid college message"]}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <p>Selected valid college: {college}</p>
                </div>

                <div className={styles.inputContainer}>
                    <LinedInput
                        id="first-name"
                        type={InputType.Text}
                        value={firstName}
                        setValue={setFirstName}
                        label="First Name"
                        required={true}
                        toggleText="Toggle Text"
                    />
                </div>
                <div className={styles.inputContainer}>
                    <LinedInput
                        id="first-name-2"
                        type={InputType.Text}
                        value={firstName}
                        setValue={setFirstName}
                        label="First Name With Validation"
                        required={true}
                        validationMessage={["Invalid first name"]}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <LinedInput
                        id="email"
                        type={InputType.Email}
                        value={email}
                        setValue={setEmail}
                        label="Email Address"
                        required={true}
                        extraInfo="We may use your email address to send you important information about your application and account(s), as well as other useful products and services."
                    />
                </div>
                <div className={styles.inputContainer}>
                    <LinedInput
                        id="email-validation"
                        type={InputType.Email}
                        value={email}
                        setValue={setEmail}
                        label="Email Address"
                        required={true}
                        extraInfo="We may use your email address to send you important information about your application and account(s), as well as other useful products and services."
                        validationMessage={["Invalid email"]}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <PhoneInput
                        id="phone"
                        value={phone}
                        setValue={setPhone}
                        label="Phone Number"
                        required={true}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <DateOfBirthInput
                        id="date-of-birth"
                        value={dateOfBirth}
                        setValue={setDateOfBirth}
                        label="Date of Birth"
                        required={true}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <SocialSecurityInput
                        id="ssn"
                        value={ssn}
                        setValue={setSSN}
                        label="Social Security Number"
                        required={true}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <MoneyInput
                        id="money"
                        value={money}
                        setValue={setMoney}
                        label="Money"
                        required={true}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <MoneyInput
                        id="money-max"
                        value={money}
                        setValue={setMoney}
                        label="Money With Max of 12"
                        required={true}
                        max={12}
                        allowDecimals={true}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <DemoInputGroup />
                </div>
                <div className={styles.inputContainer}>
                    <DemoInputGroup2 />
                </div>
                <div className={styles.inputContainer}>
                    <CalendarInput
                        id="calendar"
                        label="Pick a date"
                        value={calendarValue}
                        setValue={setCalendarValue}
                        required={true}
                    />
                </div>
                <div className={cn(styles.inputContainer, styles.cardPickerContainer)}>
                    <CardPicker
                        cardId={card}
                        onChange={setCard}
                        name="Paul Francis"
                        cardTypes={["GOLD"]}
                    />
                </div>
                <div className={styles.boxLinkContainer}>
                    <BoxLink to="/" label="See Home Page" />
                </div>
                <div className={styles.checkboxContainer}>
                    <Checkbox
                        className={styles.checkbox}
                        id="checkbox"
                        label="I am obligated to pay a mortgage, rent, etc."
                        isChecked={checkbox}
                        onChange={(e) => setCheckbox(e.target.checked)}
                    />
                    <Checkbox
                        className={styles.checkbox}
                        id="checkbox-2"
                        label="By checking this box, you have read and agree to the important information above."
                        isChecked={checkbox}
                        onChange={(e) => setCheckbox(e.target.checked)}
                        hasGradient={true}
                    />
                    <Checkbox
                        className={styles.checkbox}
                        id="checkbox-3"
                        label="HREF - By checking this box, you agree that we may provide your application decision, and if approved, your 1st Financial Bank USA card account disclosures and other communications electronically rather than by paper. Click Electronic Communications Agreement for more information."
                        isChecked={checkbox}
                        onChange={(e) => setCheckbox(e.target.checked)}
                        hasGradient={true}
                        linkText="Electronic Communications Agreement"
                        href="/"
                    />
                    <Checkbox
                        id="checkbox-4"
                        label="TO - By checking this box, you agree that we may provide your application decision, and if approved, your 1st Financial Bank USA card account disclosures and other communications electronically rather than by paper. Click Electronic Communications Agreement for more information."
                        isChecked={checkbox}
                        onChange={(e) => setCheckbox(e.target.checked)}
                        hasGradient={true}
                        linkText="Electronic Communications Agreement"
                        to="/"
                    />
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                >
                    <LinedInput
                        id="username"
                        type={InputType.Email}
                        value={username}
                        setValue={setUsername}
                        label="Username"
                        required={true}
                    />
                    <LinedInput
                        id="password"
                        type={InputType.Password}
                        value={password}
                        setValue={setPassword}
                        label="Password"
                        required={true}
                    />
                    <input type="submit" />
                </form>
                <div className={styles.inputContainer}>
                    <DownloadButton url="/" />
                </div>
                <div className={cn(gradientStyles.blue, styles.gradient)} />
                <div className={styles.relative}>
                    <ReviewCarousel reviews={reviews} clearInterval={false} />
                </div>
                <div className={cn(gradientStyles.grey, styles.gradient)} />

                <div className={styles.table}>
                    <TableDemo />
                </div>
                <div className={styles.ratingContainer}>
                    <Card>
                        <StarRating className={styles.rating} value={rating} setValue={setRating} />
                        <ReviewDescription
                            id="reviewDescription"
                            onChange={(e) => {
                                setCardDescription(e.target.value);
                            }}
                            reviewLabelText="Tell us about your experience"
                            reviewLinkText="Read our Guidelines for Reviewers"
                            reviewLinkHref=""
                            value={cardDescription}
                            message={messageToDisplay}
                        />
                        <ReviewInput
                            id="reviewTitle"
                            title="Give your review a title"
                            value={reviewTitle}
                            onChange={(e) => {
                                setReviewTitle(e.target.value);
                            }}
                            message={titleMessageToDisplay}
                        />
                    </Card>
                </div>
                <div className={styles.roundedContainer}>
                    <RoundedCard showBorder={true}>
                        <ReviewDisplay
                            description="1st Financial Bank USA allowed me to get my first credit card and I’m very thankful!"
                            dateOfReview="May 2021"
                        />
                    </RoundedCard>
                </div>
                <CheckboxEnhanced
                    className={styles.checkbox}
                    label="I have read and agree to the Important Information above"
                    hasGradient={true}
                    isChecked={checkbox}
                    onChange={(e) => setCheckbox(e.target.checked)}
                >
                    , the <TextLink to="/" text="Security Deposit Agreement" /> and{" "}
                    <TextLink to="/" text="Electronic Communications Agreement" />
                </CheckboxEnhanced>

                <Quote quote="Renting your very own apartment or buying your dream car someday will require you to have good credit. But where do you start? For those with poor or limited credit history, don’t be discouraged. A secured card is the easiest first step for establishing credit. As you purchase items and make payments on your account each month, you’ll build credit AND develop smart money habits. Soon you’ll be that much closer to reaching your financial goals." />

                <CardBanner cardImage={getSecuredCardImage()}>
                    <>
                        <div className={styles.securedCongrats}>
                            Congratulations, you’ve been approved for a secured card with an initial
                            credit limit of up to $1,000
                        </div>
                        <div className={styles.securedInfo}>
                            While you were not approved for an unsecured credit card, we can still
                            help you build your credit and take charge of your financial future.
                            Click here for details on why we couldn’t approve your unsecured
                            application
                        </div>
                        <ActionButton
                            className={styles.continue}
                            style={ActionButtonStyle.secondary}
                            label="Continue"
                            fullWidth={true}
                            type="submit"
                        />
                    </>
                </CardBanner>

                <RadioGroup
                    radioInputs={radioOptions}
                    selectedValue={radioValue}
                    setValue={(n) => setRadioValue(n)}
                />

                <div className={styles.roundedContainer}>
                    <PersonalReferralCard link="https://www.1fbusa.com/xyz123" />
                </div>
                <FundLaterReminderModal
                    isOpen={fundLaterVisible}
                    onClose={() => setFundLaterVisible(false)}
                    onSubmit={() => setFundLaterVisible(false)}
                    triggerElement={fundLaterButtonRef.current}
                    email="email@email.com"
                    lastFourPhoneDigits="1234"
                    depositOptions={["$50", "$200", "$500"]}
                />
                <Modal
                    id="modal_one"
                    isOpen={modalVisible}
                    label="Modal 1"
                    onClose={() => setModalVisible(false)}
                    onCancelLabel="Cancel"
                    triggerElement={buttonRef.current}
                    onSubmit={() => setModalVisible(false)}
                    onSubmitLabel="Submit"
                    showCancelButton={true}
                >
                    <div className={modalStyles.paragraph}>
                        Testing testing testing, paragraph 1
                    </div>
                    <div className={modalStyles.paragraph}>
                        Paragraph 2, Testing testing testing a longer string that runs onto another
                        life, testing testing testing testing
                    </div>
                </Modal>
                <Modal
                    id="modal_two"
                    isOpen={modal2Visible}
                    label="Modal 2"
                    onClose={() => setModal2Visible(false)}
                    triggerElement={button2Ref.current}
                    onSubmit={() => setModal2Visible(false)}
                >
                    <div className={modalStyles.paragraph}>
                        Testing testing testing, paragraph 1
                    </div>
                    <div className={modalStyles.paragraph}>
                        Paragraph 2, Testing testing testing a longer string that runs onto another
                        life, testing testing testing testing
                    </div>
                    <div className={cn(gradientStyles.blue, styles.gradient)} />
                    <LinedInput
                        id="first-name-modal"
                        type={InputType.Text}
                        value={firstName}
                        setValue={setFirstName}
                        label="Inserted Footer Element"
                        required={true}
                        validationMessage={["Invalid first name"]}
                    />
                </Modal>
            </IdleTimeoutWrapper>
        </ErrorBoundary>
    );
}
